<template>
        <div :class="{'list-group-item-accent-danger' : eventDateHasRequiredProducts&&!bookingHasActivePurchase, 'list-group-item-accent-light' : !eventDateHasRequiredProducts||bookingHasActivePurchase}" class="list-group-item">

            <Request
                    ref="requestChangeQuantity"
                    :onRequestSuccess="onRequestSuccessChangeQuantity"
                    method="PUT"
                    root="/event-booking-panel/change-quantity">
                <slot slot="body">
                    <Request
                            ref="requestChangeStatus"
                            :onRequestSuccess="onRequestSuccessChangeStatus"
                            method="PUT"
                            root="/event-booking-panel/change-status">
                        <slot slot="body">
                            <Request
                                    ref="requestLinkPurchase"
                                    :onRequestSuccess="onRequestSuccessLinkPurchase"
                                    method="PUT"
                                    root="/event-booking-panel/link-purchase">
                                <slot slot="body">
                                    <div class="d-flex w-100 justify-content-between">
                                        <strong class="mb-3">{{Core.User.displayName(booking.userFirstname, booking.userLastname, booking.userEmail, booking.userPhone, booking.userId)}}</strong>
                                        <b-button-group class="btn-group-sm">
                                            <b-button @click="onOpenNotesClick('normal')" v-if="userNormalNotes.length > 0" variant="danger"><i class="fa fa-warning"></i> {{userNormalNotes.length}}</b-button>
                                            <b-button @click="onOpenNotesClick('critical')" v-if="userCriticalNotes.length > 0" variant="info"><i class="fa fa-comment"></i> {{userCriticalNotes.length}}</b-button>
                                            <b-dropdown text="Options" variant="light"
                                                        class="btn-group-sm ml-2 btn-square">
                                                <b-dropdown-item @click="$router.push(Core.Text.format(Core.Definition.getDefinition('/systeme/utilisateurs/{0}'),booking.userId))" href="#"><i class="fa fa-user mr-2"></i>{{Core.Definition.getDefinition('Voir le profil')}}</b-dropdown-item>
                                                <b-dropdown-item v-if="Core.Session.AuthUser.can('event_booking_management_put_update_booking') && booking.status !== Mantle.EventDateBooking.statusWaiting && completeDisplay" @click="onChangeStatusClick(Mantle.EventDateBooking.statusWaiting)" href="#"><i class="fa fa-pause mr-2"></i>{{Core.Definition.getDefinition('Mettre en attente')}}</b-dropdown-item>
                                                <b-dropdown-item v-if="Core.Session.AuthUser.can('event_booking_management_put_update_booking') && booking.status !== Mantle.EventDateBooking.statusRegistered && completeDisplay" @click="onChangeStatusClick(Mantle.EventDateBooking.statusRegistered)" href="#"><i class="fa fa-check mr-2"></i>{{Core.Definition.getDefinition('Confirmer participation')}}</b-dropdown-item>
                                                <b-dropdown-item v-if="Core.Session.AuthUser.can('event_booking_management_put_update_booking') && booking.status !== Mantle.EventDateBooking.statusCancelled" @click="onChangeStatusClick(Mantle.EventDateBooking.statusCancelled)" href="#"><i class="fa fa-times mr-2"></i>{{Core.Definition.getDefinition('Annuler')}}</b-dropdown-item>
                                                <b-dropdown-item v-if="false" href="#"><i class="fa fa-location-arrow mr-2"></i>{{Core.Definition.getDefinition('Déplacer vers ...')}}</b-dropdown-item>
                                                <!-- Ne pas permettre de supprimer. -->
                                                <b-dropdown-item v-if="false" @click="onChangeStatusClick(Core.Instance.statusArchive)" href="#"><i class="fa fa-trash mr-2"></i>{{Core.Definition.getDefinition('Supprimer')}}</b-dropdown-item>
                                            </b-dropdown>
                                        </b-button-group>
                                    </div>
                                    <b-row class="mb-3">
                                        <b-col lg="1" md="2" sm="12">
                                            <img width="100%" :src="Core.User.displayAvatar(booking.userAvatar, booking.userAvatarDefault)" />
                                        </b-col>
                                        <b-col lg="6" md="6" sm="12">
                                            <small>
                                                <span>ID:&nbsp;{{booking.userId}}</span><br/>
                                                <span>{{Core.User.displayPhone(booking.userPhone, booking.userMobile)}}</span><br/>
                                                <span>{{booking.userEmail}}</span>
                                            </small>
                                            <br/>
                                            <div class="mt-3">
                                                <InputQuantity v-if="Core.Session.AuthUser.can('event_booking_management_put_update_booking')" :displayOnChangeValid="true" @onValidClick="onValidQuantityClick" :max="bookingActiveProductBookingLimit" :description="bookingActivePurchaseBookingCountDescription" v-model="booking.quantity" class="mr-2 pull-left"></InputQuantity>
                                                <b-button-group v-if="completeDisplay && Core.Session.AuthUser.can('event_booking_management_put_update_booking')" class="btn-group-sm pull-left">
                                                    <b-button @click="onChangeStatusClick(Mantle.EventDateBooking.statusPresent)" :class="{ 'btn-success': booking.status === Mantle.EventDateBooking.statusPresent, 'btn-light' : booking.status !== Mantle.EventDateBooking.statusPresent }">{{Core.Definition.getDefinition('Présent')}}</b-button>
                                                    <b-button @click="onChangeStatusClick(Mantle.EventDateBooking.statusAWR)" :class="{ 'btn-warning': booking.status === Mantle.EventDateBooking.statusAWR, 'btn-light' : booking.status !== Mantle.EventDateBooking.statusAWR }">{{Core.Definition.getDefinition('Abs. motivée')}}</b-button>
                                                    <b-button @click="onChangeStatusClick(Mantle.EventDateBooking.statusAWNR)" :class="{ 'btn-danger': booking.status === Mantle.EventDateBooking.statusAWNR, 'btn-light' : booking.status !== Mantle.EventDateBooking.statusAWNR }">{{Core.Definition.getDefinition('Abs. non-motivée')}}</b-button>
                                                </b-button-group>
                                            </div>
                                        </b-col>
                                        <b-col lg="5" md="4" sm="12">
                                            <div v-if="booking.status !== Mantle.EventDateBooking.statusCancelled" class="text-right">
                                                <b-button-group v-if="!bookingHasActivePurchase" class="btn-group-sm btn-square mt-3">
                                                    <b-button variant="warning">{{Core.Definition.getDefinition('Aucun produit associé')}}</b-button>
                                                    <b-dropdown class="btn-group-sm" right variant="warning">
                                                        <b-dropdown-item v-if="Core.Session.AuthUser.can('event_booking_management_put_link_purchase')" @click="$refs.modalInstanceSelectorActivePurchase.open = true" href="#"><i class="fa fa-link mr-2"></i>{{Core.Definition.getDefinition('Associer un achat')}}</b-dropdown-item>
                                                        <b-dropdown-item v-if="Core.Session.AuthUser.can('event_booking_management_put_link_purchase')" @click="$refs.modalInstanceSelectorNewPurchase.open = true" href="#"><i class="fa fa-shopping-cart mr-2"></i>{{Core.Definition.getDefinition('Nouvel achat')}}</b-dropdown-item>
                                                    </b-dropdown>
                                                </b-button-group>
                                                <b-button-group v-else class="btn-group-sm btn-square mt-3">
                                                    <b-button @click="bookingActivePurchaseRoute" variant="info">{{bookingActivePurchaseTitle}}</b-button>
                                                    <b-dropdown class="btn-group-sm" right variant="info">
                                                        <b-dropdown-item v-if="Core.Session.AuthUser.can('event_booking_management_put_unlink_purchase')" @click="$refs.modalConfirmUnlinkPurchase.open = true" href="#"><i class="fa fa-unlink mr-2"></i>{{Core.Definition.getDefinition('Dissocier l\'achat')}}</b-dropdown-item>
                                                    </b-dropdown>
                                                </b-button-group>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="eventDateHasRequiredProducts&&!bookingHasActivePurchase">
                                        <b-col>
                                            <b-alert show variant="warning">
                                                {{Core.Definition.getDefinition('Le client ne détient aucun des produits requis par l\'événement')}}
                                            </b-alert>
                                        </b-col>
                                    </b-row>
                                    <small v-if="booking.status !== Mantle.EventDateBooking.statusCancelled">{{Core.Definition.getDefinition('Réservation:')}} {{Core.Date.readableDate(booking.bookDate, 'DD MMM YYYY HH:mm')}}</small>
                                    <small v-if="booking.cancelDate !== '' && booking.status === Mantle.EventDateBooking.statusCancelled">{{Core.Definition.getDefinition('Annulation:')}} {{Core.Date.readableDate(booking.cancelDate, 'DD MMM YYYY HH:mm')}}</small>
                                </slot>
                            </Request>
                        </slot>
                    </Request>
                </slot>
            </Request>

            <Modal
                    :closeOnOk="true"
                    :caption="Core.Definition.getDefinition('Notes')"
                    ref="modalOkNotes">
                <slot slot="body">
                    <b-list-group class="list-group-accent">
                        <b-list-group-item :key="noteIndex" v-for="note, noteIndex in dataNotes" href="#">
                            <div class="pb-2">
                                {{note.message}}
                            </div>
                            <small class="text-muted mr-3">
                                <i class="fa fa-calendar"></i>&nbsp;{{ Core.Definition.getDefinition('Créé le') }} {{Core.Date.format(note.creationDate, 'DD MMM YYYY')}}
                            </small>
                        </b-list-group-item>
                    </b-list-group>
                </slot>
            </Modal>

            <ModalInstanceSelector
                    ref="modalInstanceSelectorNewPurchase"
                    root="/product/list"
                    v-model="dataNewPurchase"
                    :multiple="false"
                    :searchFormStructure="{
                        rows: [
                             {
                                cols: [

                                    {
                                        fields: [
                                            {
                                                id: 'forceRequiredProducts'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                       fields: [
                                           {
                                               id: 'id'
                                           }
                                       ]
                                    },
                                    {
                                        fields: [
                                            {
                                               id: 'title'
                                            }
                                        ]
                                     }
                                ]
                            },
                            {
                                cols: [
                                    {
                                       fields: [
                                           {
                                               id: 'type'
                                           }
                                       ]
                                    },
                                    {}
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'forceRequiredProducts',
                                type: 'checkbox',
                                labelCols: 6,
                                label: Core.Definition.getDefinition('Afficher seulement les produits requis par l\'événement'),
                                value: true,
                                onChange: function() {}
                            },
                            {
                                id: 'id',
                                type: 'number',
                                label: Core.Definition.getDefinition('ID'),
                                value: ''
                            },
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: ''
                            },
                            {
                                id: 'type',
                                type: 'select',
                                label: Core.Definition.getDefinition('Type'),
                                value: null,
                                onSelect: function() {}
                            }
                        ]
                    }"
                    :searchArgs="[
                            {
                                key: 'id',
                                value: eventDateRequiredProductIds
                            },
                            {
                                key: 'type',
                                value: [Core.Product.typeStandard, Core.Product.typeRecurringSubscription, Core.Product.typeLimitedSubscription]
                            }
                    ]"
                    :options="{
                                pagination: true,
                                header: true,
                                responsive: false,
                                striped: true,
                                headerStyle: '1',
                                emptyText: Core.Definition.getDefinition('Aucun produit à afficher'),
                                borderVariant: 'white',
                                noBody: true
                         }"
                    :columns="[
                                {
                                    label: Core.Definition.getDefinition('#'),
                                    key: 'id',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Titre'),
                                    key: 'title',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Type'),
                                    key: 'type',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Prix régulier'),
                                    key: 'Readable.regularPrice',
                                    type: 'text',
                                    sortable: true
                                }
                         ]">
            </ModalInstanceSelector>

            <ModalInstanceSelector
                    :caption="Core.Definition.getDefinition('Achats actifs')"
                    ref="modalInstanceSelectorActivePurchase"
                    root="/event-booking-panel/active-purchases"
                    v-model="dataActivePurchases"
                    :multiple="false"
                    :searchFormStructure="{
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'userFirstname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'userLastname'
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            cols: [

                                {
                                    fields: [
                                        {
                                            id: 'userEmail'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'userPhone'
                                        }
                                    ]
                                }
                            ]
                        },
                         {
                            cols: [

                                {
                                    fields: [
                                        {
                                            id: 'forceRequiredProducts'
                                        }
                                    ]
                                }

                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'userFirstname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Prénom'),
                            value: ''
                        },
                        {
                            id: 'userLastname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Nom de famille'),
                            value: ''
                        },
                        {
                            id: 'userPhone',
                            type: 'text',
                            label: Core.Definition.getDefinition('Téléphone'),
                            value: ''
                        },
                        {
                            id: 'userEmail',
                            type: 'text',
                            label: Core.Definition.getDefinition('Courriel'),
                            value: ''
                        },
                        {
                            id: 'forceRequiredProducts',
                            type: 'checkbox',
                            labelCols: 4,
                            label: Core.Definition.getDefinition('Afficher seulement achats qui contient un produit requis par l\'événement'),
                            value: true,
                            onChange: function() {}
                        }
                    ]
                }"
                    :searchArgs="[
                            {
                                key: 'requiredProductIds',
                                value: this.eventDateRequiredProductIds
                            },
                            {
                                key: 'userId',
                                value: booking.userId
                            }
                        ]"
                    :options="{
                                pagination: true,
                                header: true,
                                responsive: false,
                                striped: true,
                                headerStyle: '1',
                                emptyText: Core.Definition.getDefinition('Aucun achat à afficher'),
                                borderVariant: 'white',
                                noBody: true
                         }"
                    :columns="[
                                {
                                    label: Core.Definition.getDefinition('ID'),
                                    key: 'purchaseId',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Prénom'),
                                    key: 'userBillingFirstname',
                                    type: 'text',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Nom de famille'),
                                    key: 'userBillingLastname',
                                    type: 'text',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Produit'),
                                    key: 'productTitle',
                                    type: 'text',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Date de création'),
                                    key: 'creationDate',
                                    type: 'date',
                                    sortable: true
                                }
                         ]">
            </ModalInstanceSelector>

            <ModalConfirm
                    @onConfirm="onConfirmUnlinkPurchase"
                    :closeOnConfirm="false"
                    :caption="Core.Definition.getDefinition('Dissocier l\'achat')"
                    ref="modalConfirmUnlinkPurchase">
                <slot slot="body">
                    <Request
                            ref="requestUnlinkPurchase"
                            :onRequestSuccess="onRequestSuccessUnlinkPurchase"
                            method="PUT"
                            root="/event-booking-panel/unlink-purchase">
                        <slot slot="body">
                            <p>{{ Core.Definition.getDefinition('Voulez-vous vraiment dissocier l\'achat de cette réservation?') }}</p>
                        </slot>
                    </Request>
                </slot>
            </ModalConfirm>
        </div>
</template>

<script>
    import InputQuantity from '../components/InputQuantity'
    import ModalInstanceSelector from '../components/ModalInstanceSelector'
    import ModalConfirm from '../components/ModalConfirm'
    import Modal from '../components/Modal'
    import Request from '../components/Request'
    export default {
        name: 'eventBooking',
        components: {
            InputQuantity,
            Modal,
            ModalInstanceSelector,
            ModalConfirm,
            Request
        },
        props: {
            completeDisplay: {
                type: Boolean,
                default: function() {
                    return true
                }
            },
            booking: {
                type: Object,
                default: function() {
                    return null
                }
            },
            userActiveProducts: {
                type: Object | Boolean,
                default: function() {
                    return false
                }
            },
            eventDate: {
                type: Object | Boolean,
                default: function() {
                    return false
                }
            }
        },
        watch: {
            dataNewPurchase: {
                handler(val) {
                    let product = val[0].instance
                    switch(product.type) {
                        case Core.Product.typeOrder:
                        case Core.Product.typeStandard:
                            this.$router.push(Core.Text.format(Core.Definition.getDefinition('/commerce/commandes/nouvelle-commande/{0}/{1}'), this.booking.userId, product.id))
                            break
                        case Core.Product.typeLimitedSubscription:
                            this.$router.push(Core.Text.format(Core.Definition.getDefinition('/commerce/abonnements-limites/nouvel-abonnement/{0}/{1}/{2}'), this.booking.userId, product.id, this.booking.id))
                            break
                        case Core.Product.typeRecurringSubscription:
                            this.$router.push(Core.Text.format(Core.Definition.getDefinition('/commerce/abonnements-recurrents/nouvel-abonnement/{0}/{1}/{2}'), this.booking.userId, product.id, this.booking.id))
                            break
                    }
                },
                deep: true
            },
            dataActivePurchases: {
                handler(val) {
                    this.linkPurchase()
                },
                deep: true
            },
            booking: {
                handler(val) {
                    this.$emit('onChange', val)
                },
                deep: true
            }
        },
        mounted() {
        },
        data: () => {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataNotes: [],
                dataActivePurchases: [],
                dataNewPurchase: [],
                dataUnlinkPurchase: ''
            }
        },
        computed:{
            bookingQuantity() {
                return this.booking.quantity
            },
            userCriticalNotes() {
                let criticalNotes = []
                if (this.booking.userNotes !== undefined) {
                    let notes = Core.Value.encode(this.booking.userNotes, Core.Value.typeJSON)
                    if(notes) {
                        for(let note in notes) {
                            note = notes[note]
                            if (note.level === 'critical') {
                                criticalNotes.push(note)
                            }
                        }
                    }
                }
                return criticalNotes
            },
            userNormalNotes() {
                let normalNotes = []
                if (this.booking.userNotes !== undefined) {
                    let notes = Core.Value.encode(this.booking.userNotes, Core.Value.typeJSON)
                    if (notes) {
                        for(let note in notes) {
                            note = notes[note]
                            if (note.level === 'normal') {
                                normalNotes.push(note)
                            }
                        }
                    }
                }
                return normalNotes
            },
            eventDateRequiredProductIds() {
                if (this.eventDate !== false && this.eventDate.eventDateProductIds !== undefined && this.eventDate.eventDateProductIds != null) {
                    return this.eventDate.eventDateProductIds
                }
                return undefined
            },
            eventDateHasRequiredProducts() {
                if (this.eventDate !== false && this.eventDate.eventDateProductIds !== undefined && this.eventDate.eventDateProductIds != null) {
                    return true
                }
                return false
            },
            bookingActiveProductHasBookingLimitManagement() {
                switch(this.bookingActivePurchaseType) {
                    case Core.Product.typeRecurringSubscription:
                        if (this.booking.recurringSubscriptionBookingManagement !== undefined && (this.booking.recurringSubscriptionBookingManagement == true || this.booking.recurringSubscriptionBookingManagement == false)) {
                            return this.booking.recurringSubscriptionBookingManagement
                        }
                        break
                    case Core.Product.typeLimitedSubscription:
                        if (this.booking.limitedSubscriptionBookingLimit !== undefined) {
                            return true
                        }
                        return false
                        break
                }
                return false
            },
            bookingActiveProductBookingLimit() {
                if (this.bookingActiveProductHasBookingLimitManagement) {
                    switch(this.bookingActivePurchaseType) {
                        case Core.Product.typeRecurringSubscription:
                            if (this.booking.recurringSubscriptionBookingLimit !== undefined) {
                                return this.booking.recurringSubscriptionBookingLimit
                            }
                            break
                        case Core.Product.typeLimitedSubscription:
                            if (this.booking.limitedSubscriptionBookingLimit !== undefined) {
                                return this.booking.limitedSubscriptionBookingLimit
                            }
                            break
                    }
                }
                return 99
            },
            bookingActiveProductBookingRemaining() {
                if (this.bookingActiveProductHasBookingLimitManagement) {
                    switch(this.bookingActivePurchaseType) {
                        case Core.Product.typeRecurringSubscription:
                            if (this.booking.recurringSubscriptionBookingRemaining !== undefined) {
                                return this.booking.recurringSubscriptionBookingRemaining
                            }
                            break
                        case Core.Product.typeLimitedSubscription:
                            if (this.booking.limitedSubscriptionBookingRemaining !== undefined) {
                                return this.booking.limitedSubscriptionBookingRemaining
                            }
                            break
                    }
                }
                return 0
            },
            bookingHasActivePurchase() {
                if (Core.Validation.isId(this.booking.purchaseId)) {
                    return true
                }
            },
            bookingActivePurchaseBookingCountDescription() {
                if (this.bookingActiveProductHasBookingLimitManagement) {
                    return Core.Text.format(Core.Definition.getDefinition('Place(s) {0} sur {1}'),this.bookingActiveProductBookingRemaining,this.bookingActiveProductBookingLimit)
                }
                return Core.Definition.getDefinition('Place(s)')
            },
            bookingActivePurchaseTitle() {
                let id = this.bookingActivePurchaseId
                return this.bookingActivePurchaseTypeLabel + ' #' + id
            },
            bookingActivePurchaseId() {
                if (Core.Validation.isId(this.booking.purchaseId)) {
                    return this.booking.purchaseId
                }
            },
            bookingActivePurchaseTypeLabel() {
                let type = this.bookingActivePurchaseType
                return Core.Product.typeLabel(type)
            },
            bookingActivePurchaseType() {
                return this.booking.purchaseType
            }
        },
        methods: {
            bookingActivePurchaseRoute() {
                switch(this.booking.purchaseType) {
                    case Core.Product.typeOrder:
                    case Core.Product.typeStandard:
                        this.$router.push(Core.Definition.getDefinition('/commerce/commandes/' + this.booking.purchaseId))
                        break
                    case Core.Product.typeLimitedSubscription:
                        this.$router.push(Core.Definition.getDefinition('/commerce/abonnements-limites/' + this.booking.purchaseId))
                        break
                    case Core.Product.typeRecurringSubscription:
                        this.$router.push(Core.Definition.getDefinition('/commerce/abonnements-recurrents/' + this.booking.purchaseId))
                        break
                }
            },
            onOpenNotesClick(level) {
                this.dataNotes = []
                switch(level) {
                    case 'normal':
                        this.dataNotes = this.userNormalNotes
                        break
                    case 'critical':
                        this.dataNotes = this.userCriticalNotes
                        break
                }
                this.$refs.modalOkNotes.open = true
            },
            onChangeStatusClick(status) {
                this.$refs.requestChangeStatus.clearArgs()
                this.$refs.requestChangeStatus.addArg('eventDateBookingId', this.booking.id)
                this.$refs.requestChangeStatus.addArg('status', status)
                this.$refs.requestChangeStatus.request()
            },
            onRequestSuccessChangeQuantity(data) {
                if (data.quantity !== undefined) {
                    this.booking.quantity = data.quantity
                }
                this.$emit('onChangeStatus')
            },
            onRequestSuccessChangeStatus(data) {
                if (data.status !== undefined) {
                    this.booking.status = data.status
                }
                if (data.cancelDate !== undefined) {
                    this.booking.cancelDate = data.cancelDate
                }
                if (data.bookDate !== undefined) {
                    this.booking.bookDate = data.bookDate
                }
                this.$emit('onChangeStatus')
            },
            onConfirmUnlinkPurchase() {
                this.$refs.requestUnlinkPurchase.clearArgs()
                this.$refs.requestUnlinkPurchase.addArg('eventDateBookingId', this.booking.id)
                this.$refs.requestUnlinkPurchase.request()
            },
            onRequestSuccessUnlinkPurchase() {
                this.$refs.modalConfirmUnlinkPurchase.open = false
                this.booking.purchaseId = ''
                this.$emit('onUnlinkPurchase')
            },
            onRequestSuccessLinkPurchase(data) {
                this.booking.purchaseId = ''
                this.$emit('onLinkPurchase')
            },
            onValidQuantityClick(quantity) {
                this.$refs.requestChangeQuantity.clearArgs()
                this.$refs.requestChangeQuantity.addArg('eventDateBookingId', this.booking.id)
                this.$refs.requestChangeQuantity.addArg('quantity', quantity)
                this.$refs.requestChangeQuantity.request()
            },
            linkPurchase() {
                if (this.dataActivePurchases[0] !== undefined) {
                    if (this.dataActivePurchases[0].instance !== undefined) {
                        let purchase = this.dataActivePurchases[0].instance
                        this.$refs.requestLinkPurchase.clearArgs()
                        this.$refs.requestLinkPurchase.addArg('purchaseId', purchase.purchaseId)
                        this.$refs.requestLinkPurchase.addArg('purchaseType', purchase.purchaseType)
                        this.$refs.requestLinkPurchase.addArg('eventDateBookingId', this.booking.id)
                        this.$refs.requestLinkPurchase.request()
                    }
                }
            },
            onRequestSuccessLinkPurchase(data) {
                if (data.booking !== undefined) {
                    this.booking.purchaseId = data.booking.purchaseId
                    this.booking.purchaseType = data.booking.purchaseType

                    this.booking.recurringSubscriptionBookingLimit = data.booking.recurringSubscriptionBookingLimit
                    this.booking.limitedSubscriptionBookingLimit = data.booking.limitedSubscriptionBookingLimit
                    this.booking.recurringSubscriptionBookingManagement = data.booking.recurringSubscriptionBookingManagement
                    this.booking.recurringSubscriptionBookingRemaining = data.booking.recurringSubscriptionBookingRemaining
                    this.booking.limitedSubscriptionBookingRemaining = data.booking.limitedSubscriptionBookingRemaining
                }
                this.$emit('onLinkPurchase')
            }
        }
    }
</script>
